module.exports = __webpack_public_path__ + "static/media/Home_Civil.7b5d9e4c.jpg";